import React from 'react';
import Navbar from '../components/navbar/Navbar';

const SideBarWithNav = () => {
  return <Navbar />;
};

export default SideBarWithNav;
